import { render, staticRenderFns } from "./ReviewCardInfoItemCount.vue?vue&type=template&id=7479314e&scoped=true&"
import script from "./ReviewCardInfoItemCount.vue?vue&type=script&lang=js&"
export * from "./ReviewCardInfoItemCount.vue?vue&type=script&lang=js&"
import style0 from "./ReviewCardInfoItemCount.vue?vue&type=style&index=0&id=7479314e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7479314e",
  null
  
)

export default component.exports